<section #sidebar class="sidebar-wrapper">
  <aside class="sidebar shadow">
    <div class="content">
      <a *ngIf="!this.coreService.companyInfo.isExternalAccess" routerLink="/cadastro/vistoria" class="logo" tooltip="Listagem de Vistoria" placement="left">
        <img src="./assets/images/logobranco.png" alt="Planetun" />
      </a>
      <nav *ngIf="!this.coreService.companyInfo.isExternalAccess">
        <ul class="nav d-none d-sm-flex">
          <li class="nav-item" *ngFor="let item of items" [class.opened]="item.opened" [tooltip]="item.label"
            placement="left">
            <a class="nav-link" (click)="openItem(item)">
              <i class="material-icons" *ngIf="item.icon">{{ item.icon }}</i>
            </a>
          </li>
        </ul>
        <div class="d-sm-none menu-toggle" (click)="toggleSubmenuMobile()">
          <a tooltip="Menu">
            <i class="material-icons">menu</i>
          </a>
        </div>
      </nav>
      <div *ngIf="!this.coreService.companyInfo.isExternalAccess" class="profile-link" tooltip="Meu Perfil"
        placement="left" (click)="openProfile()">
        <a><i class="material-icons">account_circle</i></a>
      </div>
    </div>
  </aside>

  <aside class="sidebar-submenu shadow-sm py-4 px-3" [class.show-submenu]="openedItem || openedSubmenuMobile">
    <ul class="nav d-flex justify-content-between d-sm-none">
      <li class="nav-item" *ngFor="let item of items" [class.opened]="item.opened" [tooltip]="item.label"
        placement="bottom">
        <a class="nav-link" (click)="openItem(item)">
          <i class="material-icons" *ngIf="item.icon">{{ item.icon }}</i>
        </a>
      </li>
    </ul>
    <div class="sidebar-submenu-title mt-3" *ngIf="openedItem">
      <div class="flex-sidebar">
        <h4>
          <i class="material-icons" *ngIf="openedItem?.icon">{{ openedItem.icon }}</i>
          {{ openedItem?.label }}
        </h4>

        <button type="button" class="close" aria-label="Close" (click)="closeAll()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

      <div class="my-profile" *ngIf="openedItem?.label == 'Meu Perfil'">
        <span>{{profile}}</span>
        <span class="name" [innerHTML]="handleNameProfile()"></span>
        <span class="company">{{insurance.companyName}}</span>
        <span class="change" [routerLink]="['/auth/login','1']" (click)="reloadItems()">Trocar Empresa</span>
      </div>
      <div class="my-profile" *ngIf="(insurance.isProvider || insurance.isBroker) && openedItem?.label == 'Meu Perfil'">
        <span>{{profile}}</span>
        <span class="name">Seguradora</span>
        <span class="company">{{provider.companyName}}</span>
        <span class="change" [routerLink]="['/auth/login','2']" (click)="reloadItems()">Trocar Empresa</span>
      </div>
      <div class="form-perfil" *ngIf="openedItem?.label == 'Meu Perfil'">
        <button class="btn btn-outline-primary list-users myData" (click)="changeData()">Alterar Meus Dados</button>
        <div class="titulo-perfil" *ngIf="myData">
          Meus Dados
        </div>
        <div *ngIf="myData">
          <form [formGroup]="form" (ngSubmit)="save()">
            <div class="form-row">
              <div class="col">
                <app-input-text [readonly]="id" [formGroup]="form" controlName="fullName" name="fullName"
                  title="Nome"></app-input-text>
              </div>
            </div>

            <div class="form-row">
              <div class="col">
                <app-input-text [formGroup]="form" controlName="email" name="email" title="Email"></app-input-text>
              </div>
            </div>

            <div class="form-row">
              <div class="col">
                <app-input-select [formGroup]="form" [values]="genderValues" controlName="gender" name="gender"
                  title="Sexo"></app-input-select>
              </div>
            </div>
            <div class="separator"></div>
            <div class="d-flex justify-content-between my-2">
              <button type="submit" class="send-button" value="Enviar">Salvar</button>
            </div>
          </form>
        </div>

        <button class="btn btn-outline-primary list-users myData" (click)="changePassword()">Alterar Minha
          Senha</button>
        <div *ngIf="myPassword" class="myPassword">
          <form [formGroup]="formPassword" (ngSubmit)="savePassword()">

            <div class="form-group" style="margin-top: 10px;">
              <label class="label-login" for="password">Senha Atual</label>
              <input id="password" type="password" formControlName="currentPassword" appPasswordInput
                class="form-control input-login" placeholder="Senha Atual" />
            </div>

            <div class="form-group">
              <label class="label-login" for="password">Senha</label>
              <input id="password" type="password" formControlName="newPassword" appPasswordInput
                class="form-control input-login" placeholder="Nova Senha" />

              <div class="erro" *ngIf="!validatePassword(fToken.newPassword.value)">
                A senha precisa ter:
                <li>Pelo menos uma letra maiuscula</li>
                <li>Pelo menos uma letra minucula</li>
                <li>Pelo menos um número</li>
                <li>Pelo menos um caracter especial</li>
              </div>
            </div>

            <div class="form-group">
              <label class="label-login" for="password">Senha</label>
              <input id="password" type="password" formControlName="confirmPassword" appPasswordInput
                class="form-control input-login" placeholder="Confirme sua senha" />
              <div class="erro" *ngIf="!confirmPassword()">
                A senhas precisam ser iguais
              </div>
            </div>
            <div class="separator"></div>
            <div class="d-flex justify-content-between my-2">
              <button type="submit" class="send-button" value="Enviar">Salvar</button>
            </div>
          </form>
        </div>

      </div>
    </div>
    <nav *ngIf="openedItem && (openedItem | toAny)?.subitems">
      <ng-container *ngTemplateOutlet="submenu; context: { subitems: (openedItem | toAny).subitems }"></ng-container>
    </nav>
    <section *ngIf="openedItem && (openedItem | toAny)?.profile">
      <ng-container *ngTemplateOutlet="profilePage"></ng-container>
    </section>
  </aside>
</section>
<div class="sidebar-wrapper-simulator" [class.show-submenu]="openedItem || openedSubmenuMobile"></div>

<ng-template #submenu let-subitems="subitems" let-depth="depth">
  <ul class="submenu nav flex-column">
    <li class="nav-item" *ngFor="let item of subitems" [class.opened]="item.opened">
      <ng-container *ngIf="getAccess(item)">
        <a *ngIf="item.subitems?.length; else href" class="nav-link px-0 text-dark" (click)="item.opened = !item.opened"
          [class.opened]="item.opened" [ngStyle]="{ 'margin-left': ((depth || 0) * 20) + 'px' }">
          <span class="label">{{ item.label }}</span>
          <span class="expand-icon material-icons text-muted">arrow_right</span>
        </a>
        <ng-container *ngIf="item.opened">
          <ng-container *ngTemplateOutlet="submenu; context: { subitems: item.subitems, depth: depth ? depth + 1 : 1 }">
          </ng-container>
        </ng-container>
      </ng-container>
      <ng-template #href>
        <a *ngIf="!item.externalLink" class="nav-link px-0" [ngStyle]="{ 'margin-left': ((depth || 0) * 20) + 'px' }"
          (click)="toggleSubMenu()" [routerLink]="item.route">
          <span class="label">{{ item.label }}</span>
        </a>

        <a *ngIf="(item.externalLink && item.label != 'Workflow') && (item.externalLink && item.label != 'Dashboard')"
          class="nav-link px-0" [ngStyle]="{ 'margin-left': ((depth || 0) * 20) + 'px' }"
          (click)="openExternalLink(item)">
          <span class="label">{{ item.label }}</span>
        </a>
      </ng-template>

      <a *ngIf="item.externalLink  && hasAccessWorkFlow && item.label === 'Workflow'" class="nav-link px-0"
        [ngStyle]="{ 'margin-left': ((depth || 0) * 20) + 'px' }" (click)="openExternalLink(item)">
        <span class="label">{{ item.label }}</span>
      </a>

      <a *ngIf="item.externalLink  && hasAccessDashboard && item.label === 'Dashboard'" class="nav-link px-0"
        [ngStyle]="{ 'margin-left': ((depth || 0) * 20) + 'px' }" (click)="openExternalLink(item)">
        <span class="label">{{ item.label }}</span>
      </a>
    </li>
  </ul>
</ng-template>

<ng-template #profilePage>

  <div class="pt-2">
    <ng-container *ngIf="companiesToSelect" dropdown>
      <div class="company-dropdown position-relative" dropdownToggle>
        <ng-container *ngTemplateOutlet="companyLogo"></ng-container>
      </div>
      <ul id="dropdown-split" *dropdownMenu class="dropdown-menu" role="menu" aria-labelledby="button-split">
        <li role="menuitem" *ngFor="let company of companiesToSelect">
          <a class="dropdown-item" (click)="selectCompany(company)">
            <div class="company d-flex">
              <strong class="m-2 text-muted">{{ company?.name }}</strong>
            </div>
          </a>
        </li>
      </ul>
    </ng-container>
    <ng-template #userLogoWhenNotAdmin>
      <ng-container *ngTemplateOutlet="companyLogo"></ng-container>
    </ng-template>
  </div>

  <div class="mt-2">
    <button class="btn p-0 btn-link text-terciary" (click)="logout()">Sair</button>
  </div>

</ng-template>
